<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="success"
        block
        rounded
        :disabled="desabilitarEmissao()"
        >Emitir Pedido</v-btn
      >
    </template>
    <v-card>
      <v-card-title>Emitir Pedido</v-card-title>
      <v-card-text class="subtitle-1">
        Confirma a emissão do pedido para o cliente
        {{ novopedido.cliente.nome }} ??
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <btn-confirmar-emissao-pedido />
        <v-btn color="error" text rounded @click="dialog = false"
          >Não, cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BtnConfirmarEmissaoPedido from "./BtnConfirmarEmissaoPedido.vue";
export default {
  components: { BtnConfirmarEmissaoPedido },
  computed: {
    ...mapState("pedidos", ["novopedido"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapGetters("pedidos", ["clienteBloqueado"]),
    desabilitarEmissao() {
      return (
        this.novopedido.produtos.length == 0 ||
        !this.novopedido.cliente ||
        this.clienteBloqueado()
      );
    },
  },
};
</script>

<style>
</style>